/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_Monetary_CorrectionInputs */

const en_clients_payment_terms_monetary_correction = /** @type {(inputs: Clients_Payment_Terms_Monetary_CorrectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monetary correction (%)`)
};

const pt_br2_clients_payment_terms_monetary_correction = /** @type {(inputs: Clients_Payment_Terms_Monetary_CorrectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correção monetária (%)`)
};

/**
* | output |
* | --- |
* | "Monetary correction (%)" |
*
* @param {Clients_Payment_Terms_Monetary_CorrectionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_monetary_correction = /** @type {((inputs?: Clients_Payment_Terms_Monetary_CorrectionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_Monetary_CorrectionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_monetary_correction(inputs)
	return pt_br2_clients_payment_terms_monetary_correction(inputs)
});